<template>
    <div>
        <div class="row pb-3"
            v-if="isLoaded && isHaveItem">
            <campaign-item
                v-for="(campaign, k) in campaigns"
                :key="k"
                :index="k"
                :lbl="lbl"
                :campaign="campaign"
                :isSearch="isSearch"
            ></campaign-item>
        </div>
        <div v-if="isLoaded && !isHaveItem">
            <div class="wrapper-empty-img">
                <img class="empty-icon" src="../../../assets/home/icon-reward-empty2x.png"/>
            </div>
            <div class="empty-text">{{lbl.home.empty_campaign}}</div>
        </div>

        <modal view="campaign-list"
            :busModal="busModal"></modal>
    </div>
</template>
<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import DateTime from "@/helper/DatetimeHelper.js";
//component
import CampaignItem from "@/components/campaign/list/CampaignItem.vue";
//service
import BzbsCampaign from "@/service/BzbsCampaign.js";
//modal
import Modal from '@/components/modal/Modal.vue';

/**
 * property
 * @property {object} lbl Text for component.
 * @property {boolean} isLoading Loading status.
 * @property {object} listConfig Configuration for call api.
 * @property {object} filterConfig Filter configuration for call api.
 * @property {object} busEvent Bus event for parent component.
 * method
 * @method getList Get list of campaign for api.
 * @method initialLoadMore Initial scroll event to load more campaign.
 * @method loadMore Load more campaigns.
 * utility
 * @method hideLoading Hide loading screen.
 * @method showLoading Show loading screen.
 * bus event.
 * @event switchLang Reinitial campaign list with new language setup.
 * @event reinitList Reinitail campaign list.
 * @event toggleLoading Toggle loading value.
 */
export default {
    name: "CampaignList",
    components: {
        CampaignItem,
        Modal
    },
    props: {
        lbl: Object,
        isLoading: Boolean,
        objListConfig: Object,
        objFilterConfig: Object,
        busEvent: Object,
    },
    data: function() {
        return {
            campaigns: [],
            isLoaded: false,
            isHaveItem: false,
            isLoadedMore: false,
            listConfig: {},
            FilterConfig: {},
            isSearch: false,
            busModal: new Vue()
        };
    },
    created: function() {
        if (this.showLoading()) return;

        this.listConfig = this.objListConfig;
        this.FilterConfig = this.objFilterConfig;

        if (this.FilterConfig.strSearch != "")
            this.isSearch = true;
        else
            this.isSearch = false;

        this.getList();
    },
    mounted: function() {
        this.busEvent.$on("switchLang", this.switchLang);
        this.busEvent.$on("reinitList", (objConfig) => {
            if (this.showLoading()) return;
            this.listConfig = objConfig.listConfig;
            this.FilterConfig = objConfig.filterConfig;

            if (this.FilterConfig.strSearch != "")
                this.isSearch = true;
            else
                this.isSearch = false;

            this.getList();
            this.initialLoadMore();
        });
        this.initialLoadMore();
    },
    beforeDestroy: function() {
        this.removeScrollEvent();
    },
    methods: {
        //initial
        initialLoadMore: function() {
            this.removeScrollEvent();
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            };
        },
        removeScrollEvent: function() {
            window.onscroll = null;
        },
        //event
        //method
        getList: function() {
            var strBzbsToken = Account.getToken();

            BzbsCampaign.apiGetCampaign(strBzbsToken, this.listConfig, this.FilterConfig)
                .then(campaigns => {
                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;

                    if (campaigns.length == 0 && this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        var gtm = {
                            "event_label": "not_found_" + this.FilterConfig.strSearch,
                            "timestamp": DateTime.getDateTimeGTM()
                        };

                        Vue.ga.event(this, "privilege", "search", gtm.event_label, null, gtm);
                    }
                    //check is there are more campaign.
                    if (campaigns &&
                        campaigns.length < this.listConfig.defaultTopAmount)
                        this.listConfig.isSeeMoreEnable = false;

                    //reinitialize list if no skip.
                    if (this.listConfig.intSkip ==
                        this.listConfig.defaultTopAmount)
                        this.campaigns = [];

                    for (var campaign of campaigns) {
                        //TODO: Add GA Tracking.
                        this.campaigns.push(campaign);
                    }

                    this.isLoaded = true;
                    this.isHaveItem = this.campaigns.length > 0
                        ? true
                        : false;
                    this.hideLoading();
                    setTimeout(() => {
                        this.isLoadedMore = true;
                    }, 500);
                })
                .catch(error => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.hideLoading();
                    console.log(error);
                    if (error && error.data && error.data.message) {
                        var gtm = {
                            "event_label": "error_" + error.data.message,
                            "timestamp": DateTime.getDateTimeGTM()
                        };

                        Vue.ga.event(this, "privilege", "search", gtm.event_label, null, gtm);
                    }
                });
        },
        loadMore: function() {
            if (!this.listConfig.isSeeMoreEnable) return;
            if (this.showLoading()) return;
            if (!this.isLoadedMore) return;

            this.isLoadedMore = false;
            setTimeout(() => {
                this.getList();
            }, 500);
        },
        //utilities
        hideLoading: function () {
            this.toggleLoading(false);
            this.busModal.$emit('hideLoadingModal', {});
        },
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            this.busModal.$emit('showLoadingModal', {});

            return false;
        },
        //bus event
        switchLang: function() {
            this.campaigns = [];
            this.getList();
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";
//@import "@/style/base/component/campaign/list/campaignlist.scss";

.wrapper-empty-img {
    padding: 100px 0px 15px 0px;
    position: relative;
    display: flex;

    .empty-icon {
        width: 50px;
        margin: auto;
    }
}
.empty-text {
    width: 100%;
    text-align: center;
    font-weight: bold;
    color: $gray-color;
}
</style>
